// extracted by mini-css-extract-plugin
export default {"main-navigation-container":"MainNavigation_main-navigation-container__L4rfh","active":"MainNavigation_active__E87yh"};